import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { auth } from '../api/client';
import { UserMenu } from './UserMenu';

function initialsOf(name: string) {
  return name.split(' ').filter(Boolean).slice(0, 2).map(s => s[0]?.toUpperCase()).join('') || 'S';
}

/** Top-nav shell for the student workspace: My exams / Results / Re-evaluation tabs. */
export function StudentLayout({ children }: { children: ReactNode }) {
  const user = auth.getUser();
  const tabClass = ({ isActive }: { isActive: boolean }) => 'student-tab' + (isActive ? ' active' : '');

  return (
    <div className="student-shell">
      <header className="student-topbar">
        <div className="student-brand">
          <span className="student-brand-badge" aria-hidden>{initialsOf(user?.fullName ?? 'Student')}</span>
          <span className="student-brand-name">Exam App</span>
        </div>

        <nav className="student-nav" aria-label="Student sections">
          <NavLink to="/exams" end className={tabClass}>My exams</NavLink>
          <NavLink to="/exams/schedule" className={tabClass}>Schedule</NavLink>
          <NavLink to="/exams/results" className={tabClass}>Results</NavLink>
          <NavLink to="/exams/reeval" className={tabClass}>Re-evaluation</NavLink>
        </nav>

        <div className="student-topbar-right">
          <UserMenu />
        </div>
      </header>

      <main className="student-main">{children}</main>
    </div>
  );
}
